import appconfig from '../utils/appconfig';
import axios from 'axios';

const srvAutocomplete = {
    getCitiesSuggestions: function (value) {
        console.log('getCitiesSuggestions ', value);
        const inputValue = value.trim().toLowerCase();
        const inputLength = inputValue.length;

        let options={
            method: 'GET',
            crossdomain: true
          };

        if (inputLength === 0)
            return [];

        return axios('https://www.kijiji.it/ruiapi/locations/' + inputValue + '/suggest/3/3?ver=1.16.21',
        options)
            .then(function (response) {
                let cities = response.data.map(city => city.name + " (" + city.parentName + ") ");
                return cities;
            })
            .catch(function (error) {
                console.log(error);
                return [];
            });
    }
}

export default srvAutocomplete;


// WEBPACK FOOTER //
// ./src/services/srv-autocomplete.js